import { useFormikContext } from 'formik'
import { useSelector } from 'react-redux'
import { estimateConflictErrorSelector } from 'store/tasks'
import { InputLabel } from 'ui/components/forms/Input/styled'
import { AddEstimateButton } from './components/AddEstimateButton'
import {
  TaskEstimateError,
  TaskEstimatesContainer,
  TaskEstimateScrollview,
  TaskEstimatesRoot,
} from './styled'
import { useRoleCTX } from '../../context'
import { TaskEstimate } from './components/TaskEstimate/TaskEstimate'

function convertEstimateErrors(errorsObj) {
  const result = []

  Object.entries(errorsObj || {}).forEach(([key, value]) => {
    const parts = key.split('.')
    const idx = parseInt(parts[1], 10)
    result[idx] = value[0]
  })

  return result
}

export default function TaskEstimates({ executors }) {
  const formik = useFormikContext()
  const estimatesMeta = formik.getFieldMeta('estimates')
  const estimates = estimatesMeta.value ?? []
  const { canEditEstimate } = useRoleCTX()
  const estimateConflictError = useSelector(estimateConflictErrorSelector)

  const estimateErrorsArray = convertEstimateErrors(estimateConflictError)

  return (
    <TaskEstimatesRoot>
      {canEditEstimate && <AddEstimateButton estimates={estimates} />}

      {estimates.length > 0 && (
        <TaskEstimateScrollview className="task-estimate-scrollview">
          <TaskEstimatesContainer>
            <InputLabel>Ответственный</InputLabel>
            <InputLabel>Оценка</InputLabel>
            <InputLabel>Период выполнения</InputLabel>
            <span />
            {estimates.map((estimate, index) => (
              <>
                <TaskEstimate
                  key={estimate.id ?? estimate.temp_id}
                  executors={executors}
                  index={index}
                />
                {estimateErrorsArray.length > 0 && (
                  <TaskEstimateError>
                    {estimateErrorsArray[index]}
                  </TaskEstimateError>
                )}
                {estimateConflictError?.id &&
                  estimateConflictError?.id === estimate.user_id && (
                    <TaskEstimateError>
                      {estimateConflictError.message}
                    </TaskEstimateError>
                  )}
              </>
            ))}
          </TaskEstimatesContainer>
        </TaskEstimateScrollview>
      )}
    </TaskEstimatesRoot>
  )
}
